import { useSelector } from 'react-redux'
import { PreviewCompanyInfo } from '../../../common/previewCompanyInfo'
import { selectCompanyInfoData } from '../store/slice'

export const PreviewLeft = () => {
  // Use selector
  const data = useSelector(selectCompanyInfoData)

  return <PreviewCompanyInfo data={data} isDomesticSearch />
}
